/**
 * v0.13 "The Texture" — the satire toast set (RULED §8.2, all five,
 * final copy). Toast-sized, no choice, no state effect: ambient
 * dark-comedy delivery. Each piece is ONE gag concept, registered in
 * the once-across-the-facility registry — never reused in props,
 * letters, or speech loops.
 */
export const SATIRE_TOASTS: readonly string[] = [
  "An insurer approves days 1–13 of the 30-day program. Recovery is expected to occur by day 13.",
  "Corporate has renamed relapse “a re-engagement opportunity.”",
  "The lab bills a urine screen at $900. The cup cost eleven cents.",
  "Your website now says “evidence-based.” The evidence is a stock photo of a sunrise.",
  "A consultant recommends calling patients “guests.” His invoice calls himself “essential.”",
] as const;

/** Loot display items (v0.13 §8.3 launch approach: in-engine draws). */
export const LOOT_ITEMS = {
  money: ["cash", "wallet", "watch"],
  contraband: ["baggie", "pills", "shoelaces", "mouthwash", "charger"],
} as const;
